import React from 'react';

import {
    Container, Row, Col
} from 'react-bootstrap';

function LeftCard (props) {
    let style={
        border: '0px solid transparent',
    }

    if ((props.teamWin) == '1') {
        style = {
            border: '2px solid #339966',
        };
      } else if ((props.teamWin) == '2') {
        style = {
            border: '2px solid #db0000',
        };
      } else if ((props.teamWin) == '3') {
        style = {
            border: '2px solid #ffff33',
        };
      } else {
        style = {
            border: '0px solid transparent',
        };
      }
    
    return (
        <div className="">
            <h5 className="text-center text-muted">HOME</h5>
            <div className="bg-white gx-3 row shadow ms-2" style={style}> 
                <div className="column" style={{ maxWidth: '50%' }}>
                    <div className="text-secondary mt-2" align="end">
                        <small className="text-muted">{props.homeTeam}</small>
                        <h6 className="small">{props.homeWins}-{props.homeLosses}-{props.homeTies}</h6>
                    </div>
                    <div className="text-secondary mt-2" align="end">
                        <small className="text-muted">{props.homeSelectionCity}</small>
                        <h6 className="my-0">{props.homeSelectionTeam}</h6>
                    </div>
                </div>
                <div className="align-self-center column m-1 p-1" style={{ maxWidth: '45%' }}>
                        <div className="text-center">
                            <img className="thumb-img" alt={props.homeSelectionTeam} src={`/img/${props.dropdownTheme}/${props.homeSelectionTeam}.png`} width="100"/>
                        </div>
                </div>
            </div>
        </div>
    );
};

export default LeftCard;
